export const emailLogPath = '/api/public/logError';

function shouldIgnoreResourceError(source) {
  return typeof source === 'string'
    && source.indexOf('/content/Views/dashboard/images/icons/pj-scope-icons/') !== -1
    && /\.svg(\?|$)/i.test(source);
}

export function isCanceledError(error) {
  if (!error) {
    return false;
  }

  const message = error.message || '';

  return error.name === 'CanceledError'
    || error.code === 'ERR_CANCELED'
    || message === 'canceled';
}

function reportWindowError(event, reportFatalError, captureResourceErrors) {
  const target = event.target || event.srcElement;

  if (target && target !== window && (target.src || target.href)) {
    if (!captureResourceErrors) {
      return;
    }

    const source = target.src || target.href;

    if (shouldIgnoreResourceError(source)) {
      return;
    }

    reportFatalError('resource-error', {
      name: 'ResourceError',
      message: 'Resource failed to load',
      source,
    });
    return;
  }

  reportFatalError('window-error', {
    message: event.message,
    name: (event.error && event.error.name) || 'Error',
    stack: event.error && event.error.stack,
    source: event.filename,
    line: event.lineno,
    column: event.colno,
  });
}

function reportUnhandledRejection(event, reportFatalError) {
  if (isCanceledError(event.reason)) {
    return;
  }

  reportFatalError('unhandled-rejection', event.reason || {
    message: 'Unhandled promise rejection',
  });
}

export function instrumentBrowserRuntime({reportFatalError, captureResourceErrors}) {
  window.addEventListener('error', (event) => reportWindowError(event, reportFatalError, captureResourceErrors), true);
  window.addEventListener('unhandledrejection', (event) => reportUnhandledRejection(event, reportFatalError));
}
